export default {
    ReturnRefundToBeReviewed: {
        OrderNo: 'Refund order/sales Order No.',
        Document: 'Return order source',
        Return: 'Return logistics company',
        Nickname: "Buyer's nickname",
        Returned: 'Returner',
        Tripartite: 'Third-party return time',
        Approved: 'Approved',
        Approval: 'Rejected',
        form: {
            number: 'Internal return Order No.',
            return: 'Third-party return Order No.',
            Third: 'Customer Order No.',
            order: 'CSG Order No.',
            Returntype: 'Return order type',
            Type: 'Return type',
            status: 'Status',
            Approval: 'Review status',
            Doc: 'Return order source',
            refund: 'Return and refund reason',
            comments: "Buyer's remarks",
            Customer: 'Customer service remarks',
            quantity: 'Return quantity',
            Total: 'Total refund amount to be paid by buyer',
            Settlement: 'Settlement method',
            warehouse: 'Receiving warehouse',
            information: 'Return logistics information',
            nickname: "Buyer's nickname",
            Returned: 'Returner',
            person: "Returner's phone number",
            address: "Returner's address",
            store: 'Store',
            channel: 'Sales Channel',
            returntime: 'Third-party return time',
            creation: 'Internal Creation Time',
            completion: 'Return completion time',
        },
    }
};
